
import { supabase } from "@/integrations/supabase/client";
import { WidgetDefinition } from "@/components/admin/dashboard/widget-types";
import { toast } from "@/hooks/use-toast";

// Update an existing widget definition
export const updateWidgetDefinition = async (id: string, updates: Partial<WidgetDefinition>): Promise<boolean> => {
  try {
    const updateData: any = {};
    
    if (updates.title !== undefined) updateData.title = updates.title;
    if (updates.description !== undefined) updateData.description = updates.description || null;
    if (updates.defaultSize !== undefined) updateData.default_size = updates.defaultSize;
    if (updates.chartType !== undefined) updateData.chart_type = updates.chartType;
    if (updates.dashboardType !== undefined) updateData.dashboard_type = updates.dashboardType;
    if (updates.queryName !== undefined) updateData.query_name = updates.queryName || null;
    if (updates.dataFields !== undefined) updateData.data_fields = updates.dataFields || [];
    if (updates.isActive !== undefined) updateData.is_active = updates.isActive;
    if (updates.customComponent !== undefined) updateData.custom_component = updates.customComponent || null;
    
    // Always update the updated_at field
    updateData.updated_at = new Date().toISOString();
    
    const { error } = await supabase
      .from('widget_definitions')
      .update(updateData)
      .eq('id', id);
    
    if (error) throw error;
    
    return true;
  } catch (error) {
    console.error('Error updating widget definition:', error);
    toast({
      title: "Error",
      description: "Failed to update widget definition",
      variant: "destructive",
    });
    return false;
  }
};

// Toggle the active status of a widget definition
export const toggleWidgetActive = async (id: string, currentStatus: boolean): Promise<boolean> => {
  try {
    const { error } = await supabase
      .from('widget_definitions')
      .update({ is_active: !currentStatus, updated_at: new Date().toISOString() })
      .eq('id', id);
    
    if (error) throw error;
    
    return true;
  } catch (error) {
    console.error('Error toggling widget active status:', error);
    toast({
      title: "Error",
      description: "Failed to update widget status",
      variant: "destructive",
    });
    return false;
  }
};
